import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { faqItems } from '../data/offer';
import { Reveal } from './Reveal';
import { QuestionIcon } from './icons/CraftIcons';
export function FaqSection() {
  const [openId, setOpenId] = useState<string>(faqItems[0].id);
  return <section aria-labelledby="faq" className="w-full border-y border-hairline bg-ivory px-4 py-10 sm:px-6 sm:py-14 lg:py-24" data-id="element-75" data-mp="1gitw04isywjq">
      <div className="mx-auto max-w-[820px]" data-id="element-76" data-mp="249zk16ywcv54">
        <Reveal className="text-center" data-id="element-77" data-mp="28bb1gp7maa28">
          <span className="inline-flex items-center gap-2 rounded-full border border-hairline bg-cream px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-ink-soft" data-id="element-78" data-mp="28a9ogf71jdhv">
            <QuestionIcon className="h-3.5 w-3.5 text-sage" data-id="element-79" data-mp="1zh6fok7cbotk" />
            Section 7 — Straight answers
          </span>
          <h2 id="faq" className="mt-4 font-display text-3xl font-bold leading-tight text-ink sm:text-[38px]" data-id="element-80" data-mp="2n6r2xfaj188n">
            The three questions everybody asks.
          </h2>
        </Reveal>

        <div className="mt-6 space-y-3 sm:mt-9" data-id="element-81" data-mp="10tp2gmfbj0wx">
          {faqItems.map((item, index) => {
          const isOpen = openId === item.id;
          return <Reveal key={item.id} delay={index * 0.07} data-id="element-82" data-mp="1emoiqqmxcz5j" data-mpi={index}>
                <div className={`overflow-hidden rounded-2xl border bg-cream transition-colors ${isOpen ? 'border-sage shadow-soft' : 'border-hairline'}`} data-id="element-83" data-mp="19tve02rghqtg">
                  <button type="button" onClick={() => setOpenId(isOpen ? '' : item.id)} aria-expanded={isOpen} aria-controls={`${item.id}-panel`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left outline-none focus-visible:ring-2 focus-visible:ring-sage/50" data-id="element-84" data-mp="1jjomguwaxpth">
                    <span className="font-display text-lg font-bold text-ink" data-id="element-85" data-mp="3ue2jggqavoa7">
                      &ldquo;{item.question}&rdquo;
                    </span>
                    <motion.span animate={{
                  rotate: isOpen ? 45 : 0
                }} transition={{
                  duration: 0.25
                }} className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-lg font-bold leading-none ${isOpen ? 'bg-sage text-white' : 'bg-linen text-ink-soft'}`} aria-hidden="true" data-id="element-86" data-mp="237oatw6dqhpa">
                      +
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false} data-id="element-87" data-mp="2qyahbj0qjtx6">
                    {isOpen ? <motion.div id={`${item.id}-panel`} key="panel" initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: [0.22, 1, 0.36, 1]
                }} data-id="element-88" data-mp="2vvk22ld6jheo">
                        <p className="px-5 pb-5 text-sm leading-relaxed text-ink-soft sm:text-base" data-id="element-89" data-mp="oabxlenqyui2">
                          {item.answer}
                        </p>
                      </motion.div> : null}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}